// 修改 main.js 中引入 element-plus 的代码
import { createApp } from 'vue'
import App from './App.vue'
import ElementPlus from 'element-plus' //全局引入
import 'element-plus/dist/index.css'
const app = createApp(App);

app.use(ElementPlus);

app.mount('#app');


